<template>
  <div class="home">
    <div class="video_divs">
      <div class="prism-player" id="player-con"></div>
      <!-- <div class="video_rgba">
        <p>请前往中科名兽医APP观看完整视频</p>
        <button class="btnherf">去客户端观看</button>
      </div> -->
    </div>
    <div class="work_wrap">
      <div class="openappbox">
        <div class="msgbox-botton" v-if="openPopup == true">
          <span>打开中科名兽医APP,<strong>查看更多精彩</strong></span>
          <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
            <script type="text/wxtag-template">
              <style>.btn {height: 45px;}</style>
              <div class="btn">打开APP</div>
            </script>
          </wx-open-launch-app>
        </div>
        <div class="app-img" @click="openApp" v-else><img src="../../assets/liveimg/openapp.png"></div>
        <!-- <div class="app-img" @click="openPopup = true"><img src="../../assets/liveimg/openapp.png"></div> -->
      </div>
      <div class="work_top">
        <h2>
          <img class="pic" src="../../assets/liveimg/bbb.png">
          <span>{{title}}</span>
        </h2>
      </div>
      <div class="work_buttom">
        <h2>课程简介</h2>
        <p v-html="description"></p>
      </div>
    </div>
    <!-- <div class="openapp" @click="openApp">打开中科名兽医APP</div> -->
  </div>
</template>

<script>
import VueAliplayer from 'vue-aliplayer'
import { iswx, wxshare } from '@/utils/utils.js'
import { sharevideoinfo } from '@/api/resetApi.js'

export default {
  name: 'videodemand',
  inject: ['reload'],
  components: {
    'ali-player': VueAliplayer
  },
  data(){
    return{
      ip: '',
      isEndTime: false,
      videoId: '',
      share_user_id: '',
      desc: '',
      description: '',
      coverUri: '',
      playUrl: '',
      title: '',
      author: '',
      authorUri: '',
      playTime: '',
      liveData: [],
      openPopup: false,
      id: 'wxopenLanchAppId',
      appid: 'wxdc89dd9a7329fe47',
      wechatOpenAppData: '',
    }
  },
  created(){
    this.videoId = this.$route.query.videoId
    this.share_user_id = this.$route.query.share_user_id
    // this.ip = returnCitySN['cip']
    this.shareVideoInfo()
    let json = {
      "type": "video",
      "linkId": this.videoId
    }
    this.wechatOpenAppData = JSON.stringify(json)
    if (iswx() === true) {
      let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
      console.log('wechat',wechat)
      let judgewechat = wechat[1].split('.')
      // this.text = judgewechat
      if (judgewechat[0]>=8) {
        this.openPopup = true
      } else if(judgewechat[0]>=7){
        if(judgewechat[1]>=0){
            this.text = judgewechat
          if(judgewechat[2]>=12){
            this.openPopup = true
            console.log("当前符合 h5 打开指定app")
          }
        }
      }
    }
  },
  mounted() {
    if (this.openPopup == true) {
      var btn = document.getElementById(this.id)
      btn.addEventListener('launch', e => {
        console.log('success');
      });
      btn.addEventListener('error',  e => {
        this.text = e.detail.errMsg
        if (e.detail.errMsg == 'launch:fail') {
          window.location = 'http://t.cn/Aijv8II4'
        } else {
          this.$createToast({
            txt: e.detail,
            type: 'error'
          }).show()
        }
      });
    }
  },
  methods: {
    async shareVideoInfo() {
      let data = {
        video_id: this.videoId,
        user_id: this.ip,
        share_user_id: this.share_user_id
      }
      const res = await sharevideoinfo(data)
      console.log('res222222222=',res)
      try {
        if (res.data.code === 1) {
          let reg = new RegExp("\r\n", "g");
          this.liveData = res.data.obj[0]
          this.desc = this.liveData.description
          this.description = this.liveData.description.replace(reg, "<br/>")
          this.coverUri = this.liveData.cover_uri
          this.playUrl = this.liveData.play_url
          this.title = this.liveData.title
          this.author = this.liveData.video_author
          this.authorUri = this.liveData.video_author_img_uri
          this.playTime = this.liveData.play_time

          let videodesc = this.author+'-'+this.desc
          wxshare(this.coverUri,this.title,videodesc);
          this.videoPlayer()
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    videoPlayer(type) {
      let that = this
      that.player = new Aliplayer({
        "id": "player-con",
        "source": that.playUrl,
        'cover': that.coverUri,
        "width": "100%",
        "height": "100%",
        "autoplay": false,
        "isLive": false,
        "rePlay": true,
        "playsinline": true,
        "preload": true,
        disableSeek: true,
        // "skinLayout": [{name: "bigPlayButton", align: "blabs", x: 0, y: 80}],
        "controlBarVisibility": "hover",
        "useH5Prism": true
      },function(player){
        let u = navigator.userAgent;
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        console.log('liveEnd=',that.liveEnd)
        if (isIOS) {
          player.on('canplaythrough',function  (e) {
            if(!that.seeked) {
              console.log('seeked1=',that.seeked)
              that.seeked = true;
              if (parseInt(that.playTime) > 0) {
                // let num1 = 600
                let num1 = parseInt(that.playTime)
                player.seek(num1)
                player.play()
              } else {
                player.play()
              }
            }
          });
        } else {
          console.log('seeked2=',that.seeked)
          if (parseInt(that.playTime) > 0) {
            // let num = 400
            let num = parseInt(that.playTime)
            player.seek(num)
            player.play()
          } else {
            player.play()
          }
        }
      });
    },
    openApp() {
      window.location = 'http://t.cn/Aijv8II4'
      // this.$router.push({
      //   name: 'OpenApp',
      //   query:{
      //     videoId: this.videoId,
      //   }
      // })
    }
  }
}
</script>

<style lang="scss">
  .home {
    max-width: 768px;
    margin: 0 auto;
  }
  .prism-info-display {
    padding: 0!important;
  }
  .prism-big-play-btn {
    left: 50%!important;
    top: 50%!important;
    margin-left: -32px!important;
    margin-top: -32px!important;
  }
  .openapp{
    display: block;
    width:3.9rem;
    height: .5rem;
    background: -webkit-linear-gradient(left, #0097e0 , #004ea2);
    // background: -o-linear-gradient(left, #0097e0, #004ea2);
    // background: -moz-linear-gradient(left, #0097e0, #004ea2);
    // background: linear-gradient(left,#0097e0, #004ea2);
    background-size:100% 100%;
    position: fixed;
    bottom: 0;
    line-height: .5rem;
    text-align: center;
    font-size: .16rem;
    font-weight: 600;
    color: #fff;
  }
  .work_wrap {
    // padding: .2rem 0 .2rem .1rem;
  }
  .work_top{
    padding: .2rem .1rem;
    border-bottom: .1rem solid #F5F5F5;
    h2 {
      text-align: left;
      font-size: .14rem;
      .pic{
        width: .2rem;
        vertical-align: middle;
        margin-right: .05rem;
      }
      span {
        font-weight: 600;
      }
    }
  }
  .work_buttom {
    padding: .2rem 0 .2rem .1rem;
    h2 {
      text-align: left;
      padding-bottom: .1rem;
      font-size: .14rem;
      color: #0051A5;
      font-weight:500;
      border-bottom: 0.01rem solid #CCCCCC;
    }
    p {
      text-align: left;
      padding: .1rem .1rem .6rem 0;
      font-size: .1rem;
      line-height: .2rem;
    }
  }

  .video_divs{
    position: relative;
    // width: 100%;
    height: 2.6rem;
    background: #000;
    vertical-align: middle;
  }

  .openappbox {
    padding: 0.15rem;
    text-align: center;
    font-size: 0;
    .app-img {
      display: inline-block;
      width: 100%;
      height: 0.54rem;
      img {
        width: 100%;
      }
    }
  }
  .msgbox-botton {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 0.45rem;
    background: linear-gradient(294deg,#127be4 15%, #00a4ff 97%);
    border-radius: 0.04rem;
    font-size: 0.15rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    line-height: 0.45rem;
    strong {
      margin-left: 0.2rem;
    }
    .launch-btn {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      opacity: 0;
    }
  }
</style>
